import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor() { }

  emailQuotation(
    customerName: string,
    providerName: string,
    linkServiceCenter: string,
    serviceName: string
  ) {
    var htmlEmailEs = `<!DOCTYPE html>
	<html>
	<head>
		<title></title>
		<script src="https://use.fontawesome.com/4c38346550.js"></script>
	</head>
<body style="overflow-x: hidden; margin: 0px;">

</body>
<table
  cellpadding="0"
  cellspacing="0"
  border="0"
  width="100%"
  bgcolor="#F8F7FF"
  style="padding: 0; margin: 0; line-height: 1px; font-size: 1px;
      background: #FAF9F6;"
>
  <tbody>
    <tr>
      <td
        align="center"
        style="padding: 0; margin: 0; line-height: 1px; font-size: 1px;     background: #FAF9F6;"
      >
        <table
          class="header"
          align="center"
          width="600"
          style="
            width: 100%;
            padding: 0;
            margin: 0;
            line-height: 1px;
            font-size: 1px;
                background: #FAF9F6;
          "
          bgcolor="#F8F7FF"
          cellpadding="0"
          cellspacing="0"
          border="0"
        >
          <tbody
            style="
              background: #FAF9F6;

              background-repeat: no-repeat;
              height: 226px;
            "
          >
            <tr align="center">

              <td
                align="center"
                style="padding: 0; margin: 0; line-height: 1px; font-size: 1px;

                "
              >
                <a
                  style="
                    text-decoration: none;
                    border-style: none;
                    border: 0;
                    padding: 0;
                    margin: 0;
                  "
                >
                  <img
                    width="32"
                    align="center"
                                         src="https://myservy.com/wp-content/uploads/2024/09/Banner-mail-myservy.jpg"
                    style="
                      width: 100%;

                      margin: 0;
                      padding: 0;
                      display: block;
                      border: none;
                      outline: none;
                          max-width: 100%;

                    "
                    class="logo"
                    data-bit="iit"
                  />
                </a>
              </td>

            </tr>
            <tr></tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td
        align="center"
        style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
      >
        <table
          align="center"
          width="600"
          style="
            width: 100%;
            background-color: #ffffff;
            padding: 0;
            margin: 0;
            line-height: 1px;
            font-size: 1px;
          "
          bgcolor="#ffffff"
          cellpadding="0"
          cellspacing="0"
          border="0"
        >
          <tbody style="position: relative;
    z-index: 99;">
            <tr align="left;">

              <td
                align="center;"
                style="padding: 0; margin: 0; line-height: 1px; font-size: 1px; background-color: #FAF9F6;"
              >
                <table
                  cellpadding="0"
                  cellspacing="0"
                  border="0"
                  style="
                    padding: 45px 44px 41px 33px;
                    margin: 0 auto;
                    line-height: 1px;
                    font-size: 1px;
                      min-height: 339px;
    background: #fff;
    box-shadow: 0px 8px 24px -4px rgba(151, 161, 175, 0.38);
        max-width: 536px;
    border-radius: 15px;
    margin-bottom: 33px;
    margin-top: -30px;



                  "
                >
                  <tbody>

                    <tr><td
                      align="left;"
                      style="
                           padding: 0;
  margin: 0;
  line-height: 1px;
  font-family: 'Roboto', sans-serif;
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  color: #000;
  text-align: left;
  text-decoration: none;"
                    >
                    Estimado/a </td></tr>

<tr><td
                        align="left;"
                        style="
                             padding: 0;
    margin: 0;
    line-height: 1px;
    font-family: 'Roboto', sans-serif;
    font-size: 32px;
    line-height: 40px;
    font-weight: 600;
    color: #FF0066;
    text-align: left;
    text-decoration: none;

                        "
                      >
                      ${customerName}</td></tr>
                      <tr style="height: 32px;"></tr>
                    <tr>
                      <td
                        align="left;"
                        style="
                             padding: 0;
    margin: 0;
    line-height: 1px;
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    line-height: 30px;
    font-weight: 600;
    color: #000;
    text-align: left;
    text-decoration: none;

                        "
                      >
                      ${providerName}
                      </td>
                    </tr>
                    <tr>
                      <td
                        align="left;"
style="padding: 0; margin: 0; line-height: 1px; font-family: 'Roboto', sans-serif; font-weight: 600;
font-size: 16px; line-height: 20px; color: #FF0066; text-align: left; text-decoration: none;"
                      >
                      ${serviceName}
                      </td>
                    </tr>
                    <tr>
                      <td
                        align="left;"
                        style="
                          padding: 0;
                          margin: 0;
                          color: #000;
                          font-family: 'Roboto', sans-serif;
                          font-size: 20px;
                          font-style: normal;
                          font-weight: 600;
                          line-height: 130%;
                          letter-spacing: 0.24px;
                          text-align: left;
                          text-decoration: none;
                        "
                      >

                      </td>
                    </tr>
                      <tr>
                      <td
                        align="left;"
                        style="
                          padding: 0;
                          margin: 0;
                          color: #000;
                          font-family: 'Roboto', sans-serif;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 600;
                          line-height: 130%;
                          letter-spacing: 0.24px;
                          text-align: left;
                          text-decoration: none;
                        "
                      >

                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding: 10px;
                          margin: 10px;
                          line-height: 1px;
                          font-size: 1px;
                        "
                      ></td>
                    </tr>
                    <tr>
                      <td
                        height="6"
                        style="
                          padding: 0;
                          margin: 0;
                          line-height: 1px;
                          font-size: 1px;
                        "
                      ></td>
                    </tr>
                    <tr>
                      <td
                        height="6"
                        style="
                          padding: 0;
                          margin: 0;
                          line-height: 1px;
                          font-size: 1px;
                        "
                      ></td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding: 0;
                          margin: 0;
                          line-height: 1px;
                          font-size: 1px;
                        "
                      >
                        <table
                          width="100%"
                          align="center"
                          cellspacing="0"
                          border="0"
                          style="
                            padding: 0;
                            margin: 0;
                            line-height: 1px;
                            font-size: 1px;
                          "
                        >
                          <tbody>
                            <tr>
                              <td
                                align="center"
                                style="
                                  padding: 0;
                                  margin: 0;
                                  line-height: 1px;
                                  font-size: 1px;
                                "
                              ></td>
                              </tr>
                              <table
                                width="100%"
                                align="center"
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                style="
                                  padding: 0;
                                  margin: 0;
                                  line-height: 1px;
                                  font-size: 1px;
                                  background-color: #FAF9F6;

                                      border-radius: 15px 15px 15px 15px;
                                          padding: 18px 24px 34px;
                                "
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      style="

                                        line-height: 1px;
                                        font-size: 1px;
                                      "
                                    ></td>
                                  </tr>
                                  <tr align="center">

                                  </tr>
                                  <tr>
                                    <td
                                      style="
                                        padding: 10px;
                                        margin: 10px;
                                        line-height: 1px;
                                        font-size: 1px;
                                      "
                                    ></td>
                                  </tr>

                                  <tr align="center">
                                    <td
                                      align="center;"
                                      style="
                                        align-items: center;
                                        padding: 0;
                                        margin: 0;
                                        line-height: 16px;
                                        font-size: 1px;
                                        font-family: 'Roboto', sans-serif;

                                        line-height: 20px;

                                        color: #1e1e1e;
                                        text-align: left;
                                        text-decoration: none;
                                            font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24.4px;
    margin-bottom: 10px;
                                      "
                                    >
<p>Te informamos que la cotización por el servicio ${serviceName} de ${providerName} ya está disponible.</p>


                                    </td>

                                  </tr>

                                  <tr>
                                    <td
                                      align="center;"
                                      style="
                                          align-items: center;
                                        padding: 0;
                                        margin: 0;
                                        line-height: 16px;
                                        font-size: 1px;
                                        font-family: 'Roboto', sans-serif;

                                        line-height: 20px;

                                        color: #1e1e1e;
                                        text-align: left;
                                        text-decoration: none;
                                            font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24.4px;
    margin-bottom: 10px;
    padding-bottom: 28px;
                                      "
                                    >
<p></p>



                                     <th
                                      align="center"
                                      style="
                                        padding: 0;
                                        margin: 0px;
                                        line-height: 1px;
                                        font-size: 1px;
                                        font-family: 'Roboto', sans-serif;
                                        text-decoration: none;
                                        height: 34px;
                                      "
                                    >

                                    </th>

                                    </td>
                                  </tr>
                                  <tr align="center">
                                    <td
                                      align="center"
                                      style="
                                        padding: 0;
                                        margin: 0px;
                                        line-height: 1px;
                                        font-size: 1px;
                                        font-family: 'Roboto', sans-serif;
                                        text-decoration: none;
                                      "
                                    >
                                      <a
                                        href=${linkServiceCenter}
                                        target="_blank"
                                        style="
                                          align-items: center;
                                          font-size: 14px;
                                          line-height: 18px;
                                          font-weight: 500;
                                          background-color: #FF0066;
                                          color: #fff;
                                          text-align: center;
                                          padding: 10px;
                                          border-radius: 15px;
                                          text-decoration: none;
                                          font-weight: 600;
                                          box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.20), 0px 2px 1px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14);
                                        width: 220px;
                                        display: inline-block
                                        "
                                        >IR AL CENTRO DE SERVICIO</a>
                                    </td>
                                  </tr>




                                </tbody>


                            </tr>
                          </tbody>
                        </table>
<table
                                width="100%"
                                align="center"
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                style="
                                  padding: 0;
                                  margin: 0;
                                  line-height: 1px;
                                  font-size: 1px;


                                      border-radius: 15px 15px 0px 0px;

                                "
                              >



                            </tr>

                          </tbody>
                        </table>
                      </td>
                    </tr>


                  </tbody>
                </table>

<table  style="background-color: #FAF9F6;     padding: 150px 33px 90px 40px;
    width: 100%;  max-width: 536px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
" align="center" ><tbody><tr><td><p style="font-family: 'Roboto', sans-serif; text-align: center;"><span style="
font-size: 14px;
line-height: 18px;
font-weight: 700;
color: #7B7B7B;
">Recibiste este email porque realizaste el registro de una cuenta en myservy con esta dirección de email.</span></p>

</td></tr></tbody></table>
<table
class="footer"
cellpadding="0"
cellspacing="0"
border="0"
width="100%"
align="center"
width="600"
style="
  width: 100%;
  background-color: #000;
  padding: 29px 36px;
  margin: 0;
  line-height: 1.1rem;
  font-size: 1px;
"
>
<tbody>
  <tr>
     <th style="width: 100%" align="center">
      <a href="https://myservy.com/">
        <img
          src="https://myservy.com/wp-content/uploads/2024/09/Group-490.png"
          width="111"
          height="21"
          style="
            display: block;
            border: 0;
            outline: none;
            text-decoration: none;
            margin-top: 5px;

            max-width: 100%;
            width: 100%;
            min-width: 120px;
            object-fit: contain;
            text-align: left;
          "
        />
      </a>
      <p
      style="
       color: #FFF;
font-family: Roboto;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 16px; /* 133.333% */
letter-spacing: 0.048px;
text-align: center;
margin-top: 5px;
      "
    >
    myservy todos los derechos reservados 2023
    </p>
    </th>
  </tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</html>`;
    return htmlEmailEs;
  }

  emailRecharge(
    customerName: string,
    providerName: string,
    serviceName: string,
    linkServiceCenter: string,
    color: string
  ) {
    var htmlEmailEs = `<!DOCTYPE html>
	<html>
	<head>
		<title></title>
		<script src="https://use.fontawesome.com/4c38346550.js"></script>
	</head>
		<body>
			<table
			cellpadding="0"
			cellspacing="0"
			border="0"
			width="100%"
			bgcolor="#F5F8FA"
			style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
		>
			<tbody>
			<tr>
				<td
				align="center"
				style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
				>
				<table
					class="header"
					align="center"
					width="600"
					style="
					width: 600px;
					padding: 0;
					margin: 0;
					line-height: 1px;
					font-size: 1px;
					"
					bgcolor="#ffffff"
					cellpadding="0"
					cellspacing="0"
					border="0"
				>
					<tbody
					style="
						background-color: #fff;

						background-repeat: no-repeat;
						height: 226px;
					"
					>
					<tr align="center">
						<td
						width="24"
						style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
						></td>
						<td
						align="center"
						style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
						>
						<a
							style="
							text-decoration: none;
							border-style: none;
							border: 0;
							padding: 0;
							margin: 0;
							"
						>
							<img
							width="32"
							align="center"
                            src="${environment.api}/FileUpload/20231003112234-logo-tecnonet.png"
							style="
								width: auto;
								margin: 0;
								padding: 0;
								display: block;
								border: none;
								outline: none;
							"
							class="logo"
							data-bit="iit"
							/>
						</a>
						</td>
						<td
						width="24"
						style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
						></td>
					</tr>
					<tr></tr>
					</tbody>
				</table>
				</td>
			</tr>
			<tr>
				<td
				align="center"
				style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
				>
				<table
					align="center"
					width="600"
					style="
					width: 600px;
					background-color: #ffffff;
					padding: 0;
					margin: 0;
					line-height: 1px;
					font-size: 1px;
					"
					bgcolor="#ffffff"
					cellpadding="0"
					cellspacing="0"
					border="0"
				>
					<tbody>
					<tr align="left;">
						<td
						width="30"
						style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
						></td>
						<td
						align="left;"
						style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
						>
						<table
							cellpadding="0"
							cellspacing="0"
							border="0"
							style="
							padding: 50px;
							margin: 0;
							line-height: 1px;
							font-size: 1px;
							min-height: 339px;
							border-radius: 25px;
							background: #fff;
							box-shadow: 0px 8px 24px -4px rgba(151, 161, 175, 0.38);
							margin: -70px 33px 33px;
							"
						>
							<tbody>
							<tr>
								<td
								align="left;"
								style="
									padding: 0;
									margin: 0;
									line-height: 1px;
									font-size: 1px;
									font-family: 'Roboto', sans-serif;
									font-size: 24px;
									line-height: 32px;
									font-weight: bold;
									color: #292f33;
									text-align: left;
									text-decoration: none;
								"
								>
								Estimado/a<br />
								<span style="color: #e74225">${customerName}</span>
								</td>
							</tr>
							<tr>
								<td
								height="24"
								style="
									padding: 0;
									margin: 0;
									line-height: 1px;
									font-size: 1px;
								"
								></td>
							</tr>
							<tr>
								<td
								align="left;"
								style="
									padding: 0;
									margin: 0;
									line-height: 16px;
									font-size: 1px;
									font-family: 'Roboto', sans-serif;
									font-size: 14px;
									line-height: 20px;
									font-weight: 400;
									color: #292f33;
									text-align: justify;
									text-decoration: none;
								"
								>
								Le informamos que su recarga ha sido exitosa.
								Puede verificar el estado de su servicio a través del siguiente enlace:
								<a style="padding-left:2rem;font-size:13px;" href="${linkServiceCenter}">
								${linkServiceCenter}
								</a>
								</td>
							</tr>
							<tr>
								<td
								height="6"
								style="
									padding: 0;
									margin: 0;
									line-height: 1px;
									font-size: 1px;
								"
								></td>
							</tr>
							<tr>
								<td
								style="
									padding: 0;
									margin: 0;
									line-height: 1px;
									font-size: 1px;
								"
								>
								<table
									width="100%"
									align="center"
									cellspacing="0"
									border="0"
									style="
									padding: 0;
									margin: 0;
									line-height: 1px;
									font-size: 1px;
									"
								>
									<tbody>
									<tr>
										<td
										align="center"
										style="
											padding: 0;
											margin: 0;
											line-height: 1px;
											font-size: 1px;
										"
										></td>
										<table
										width="100%"
										align="center"
										cellpadding="0"
										cellspacing="0"
										border="0"
										style="
											padding: 0;
											margin: 0;
											line-height: 1px;
											font-size: 1px;
										"
										>
										<tbody>
											<tr>
											<td
												style="
												padding: 15px;
												margin: 15px;
												line-height: 1px;
												font-size: 1px;
												"
											></td>
											</tr>

											<tr align="center">
											<td
												align="center"
												style="
												padding: 0;
												margin: 0px;
												line-height: 1px;
												font-size: 1px;
												font-family: 'Roboto', sans-serif;
												text-decoration: none;
												"
											>

											</td>
											</tr>
											<tr>
											<td
												style="
												padding: 15px;
												margin: 15px;
												line-height: 1px;
												font-size: 1px;
												"
											></td>
											</tr>
											<tr align="center">
											<td
												align="center"
												style="
												padding: 0;
												margin: 0px;
												line-height: 1px;
												font-size: 1px;
												font-family: 'Roboto', sans-serif;
												text-decoration: none;
												"
											>

											</td>
											</tr>
											<tr>
											<td
												height="10"
												style="
												height: 10px;
												padding: 0;
												margin: 0px;
												line-height: 1px;
												font-size: 1px;
												"
											></td>
											</tr>
										</tbody>
										</table>
									</tr>
									</tbody>
								</table>
								</td>
							</tr>
							<tr>
								<td
								height="14"
								style="
									padding: 0;
									margin: 0;
									line-height: 1px;
									font-size: 1px;
								"
								></td>
							</tr>
							</tbody>
						</table>
						<table
							cellpadding="0"
							cellspacing="0"
							border="0"
							width="100%"
							align="center"
							width="600"
							style="
							width: 600px;
							background-color: #ffffff;
							padding: 20px 60px 30px;
							margin: 0;
							line-height: 1.1rem;
							font-size: 1px;
							"
						>
							<tbody style="background-color: #fff; padding: 60px 50px">
							<tr
								style="
								font-size: 14px;
								font-style: normal;
								font-weight: 400;
								color: #7b7b7b;
								"
							>
								<td>
								Recibiste este email porque realizaste el registro de
								una cuenta en myservy con esta dirección de email. Si
								piensas que fue un error, por favor ignora este email,
								no te preocupes la cuenta aún no ha sido creada.
								</td>
							</tr>
							</tbody>
						</table>

						<table
							class="footer"
							cellpadding="0"
							cellspacing="0"
							border="0"
							width="100%"
							align="center"
							width="600"
							style="
							width: 600px;
							background-color: #1d1d1d;
							padding: 29px 36px;
							margin: 0;
							line-height: 1.1rem;
							font-size: 1px;
							"
						>
							<tbody>
							<tr>
								<th style="width: 30%">
								<a href="https://tecnonet.com.ve/">
									<img
                                    src="${environment.api}/FileUpload/20231003112414-logo-footer.png"
									width="111"
									height="21"
									style="
										display: block;
										border: 0;
										outline: none;
										text-decoration: none;
										margin: auto;
										margin-top: 5px;
									"
									/>
								</a>
								</th>
								<th style="width: 20%">
								<a
									href="https://www.instagram.com/tecnonet_ve/"
									style="margin-left: 7px"
								>
									<img
									src="https://firebasestorage.googleapis.com/v0/b/servlymaindev.appspot.com/o/HTMLMails%2FInstagram.png?alt=media&token=9512dcbd-cbc9-494f-a82b-5ec472d79182&_gl=1*hp0od5*_ga*MTg4ODU0MTgyOS4xNjg5MjU4MzYx*_ga_CW55HF8NVT*MTY5NTkxNDM3MC4xMTcuMS4xNjk1OTE0NTAzLjYwLjAuMA"
									alt="Instagram"
								/></a>
								<a
									href="https://www.facebook.com/tecnonet.ve"
									style="margin-left: 7px"
									><img
									src="https://firebasestorage.googleapis.com/v0/b/servlymaindev.appspot.com/o/HTMLMails%2FFacebook.png?alt=media&token=58c90b7a-5d02-41cc-9cf2-ffb6afcfcc41&_gl=1*93qj0u*_ga*MTg4ODU0MTgyOS4xNjg5MjU4MzYx*_ga_CW55HF8NVT*MTY5NTkxNDM3MC4xMTcuMS4xNjk1OTE0NTI1LjM4LjAuMA"
									alt="Facebook"
								/></a>
								</th>
								<th style="width: 50%">
								<p
									style="
									color: #fff;
									text-align: left;
									letter-spacing: normal;
									line-height: 1.27;
									font-style: normal;
									font-stretch: normal;
									font-weight: 300;
									font-size: 12px;
									font-family: Roboto;
									margin: 0%;
									"
								>
									myservy todos los derechos reservados 2023.
								</p>
								</th>
							</tr>
							</tbody>
						</table>
						</td>
					</tr>
					</tbody>
				</table>
				</td>
			</tr>
			</tbody>
	</table>
		</body>
	</html>`;
    return htmlEmailEs;
  }
  emailInviteMyservy(
    language: number,
    accountName: string,
    userName: string,
    pass: any,
    hrefAccept: any,
    hrefDecline: any
  ) {
    var htmlEmailEs = `<!DOCTYPE html>
	  <html>
	  <head>
		  <title></title>
	  </head>
	  <body style="font-family: Verdana, Geneva, Tahoma, sans-serif;">
		  <div style="width: 700px;min-width:700px;max-width:700px;height: 555px !important;max-height: 667px !important;min-height: 555px !important;margin:auto;padding: 25px 30px;">
			  <div>
                  <img src="${environment.appurl}/resources/MyservyLogo.png" width="187" height="36" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
				  <span style="color:#202124;font-size: 14px;margin-left: 14px;">Clientes más cerca de ti</span>
			  </div>
			  <div style="width: 75%;margin: auto;margin-top: 45px;margin-bottom: 50px;padding: 15px 25px;display: flex;flex-direction: column;align-items: center;position: relative;min-height: 400px;max-height: 595px;">
				  <table style="width: 400px;text-align: center; min-height: 370px;min-width: 512px;">
					  <tr>
						  <td style="font-size: 25px;color: #202124;width: 70%;margin: auto;">
							  Únete al equipo de <b>${accountName}</b> en el espacio de trabajo de myservy
							  <hr style="border-color: #e5e1e1;margin-top: 36px;width: 70%;margin-bottom: 0px;">
						  </td>
					  </tr>
					  <tr>
						  <td style="font-size: 21px;color: #ff0066;font-weight: bold;">
							  ${userName} te invitó
							  <br>
							  <br>
							  <p style='color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px;font-weight: 100;'>
							  Su contraseña de acceso es:
							  </p>
							  <p style='color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px; font-weight: bold;'>
								  ${pass}
							  </p>
						  </td>
					  </tr>
					  <tr>
						  <td>
							  <p style="font-size: 13px;color: #707070;width: 70%;margin: auto;">
								  Haz clic en el botón que se encuentra abajo para aceptar la invitación y te ayudaremos a comenzar.
							  </p>
							  <a href="${hrefAccept}" class="es-button" target="_blank" style="background:#ff0066;display:inline-block;border-radius:5px;width:auto;margin-top: 20px;margin-bottom: 5px;color: white;font-size: 18px;text-decoration: none;padding: 10px 25px;">
								  Aceptar invitación
							  </a><br>
							  <span style="font-size: 13px;color: #707070;margin-top: 10px;">
								  o  <a href="${hrefDecline}" style="text-decoration: underline;color:#ff0066">declinar</a>
							  </span>
						  </td>
					  </tr>
				  </table>
			  </div>
			  <div style="display: flex;flex-direction: row;justify-content: space-between;width: 700px;">
				  <span style="color:#707070 !important;font-size: 12px;">Copyright © 2020 myservy, All rights reserved.</span>
				  <span style="color:#ff0066 !important; margin-left: auto !important;font-size: 12px;">Powered by <b style="color:#ff0066 !important;text-decoration: none;">myservy.com</b></span>
			  </div>
		  </div>
	  </body>
	  </html>`;
    var htmlEmailEn = `<!DOCTYPE html>
	  <html>
	  <head>
		  <title></title>
	  </head>
	  <body style="font-family: Verdana, Geneva, Tahoma, sans-serif;">
		  <div style="width: 700px;min-width:700px;max-width:700px;height: 555px !important;max-height: 667px !important;min-height: 555px !important;margin:auto;padding: 25px 30px;">
			  <div>
                  <img src="${environment.appurl}/resources/MyservyLogo.png" width="187" height="36" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic">
				  <span style="color:#202124;font-size: 14px;margin-left: 24px;">Clients closer to you</span>
			  </div>
			  <div style="width: 75%;margin: auto;margin-top: 45px;margin-bottom: 50px;padding: 15px 25px;display: flex;flex-direction: column;align-items: center;position: relative;min-height: 400px;max-height: 595px;">
				  <table style="width: 370px;text-align: center; min-height: 370px;min-width: 397px;margin: auto;">
					  <tr>
						  <td>
							  <span style="font-size: 25px;color: #202124;width: 50%;margin: auto;">
								  Join the <b>${accountName}</b> team in the myservy workspace
							  </span>
							  <hr style="border-color: #e5e1e1;margin-top: 36px;width: 70%;margin-bottom: 0px;">
						  </td>
					  </tr>
					  <tr>
						  <td style="font-size: 21px;color: #ff0066;font-weight: bold;">
							  <br>
							  ${userName} invited you
							  <br>
							  <br>
							  <p style='color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px;font-weight: 100;'>
								  Your access password is:
							  </p>
							  <p style='color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px; font-weight: bold;'>
							  	${pass}
							  </p>
						  </td>
					  </tr>
					  <tr>
						  <td>
							  <p style="font-size: 13px;color: #707070;width: 80%;margin: auto;">
								  Click on the button below to accept the invitation and we will help you get started.
							  </p>
							  <a href="${hrefAccept}" class="es-button" target="_blank" style="background:#ff0066;display:inline-block;border-radius:5px;width:auto;margin-top: 20px;margin-bottom:5px;color: white;font-size: 18px;text-decoration: none;padding: 10px 25px;">
								  Accept invitation
							  </a><br>
							  <span style="font-size: 13px;color: #707070;margin-top: 10px;">
								  or  <a href="${hrefDecline}" style="text-decoration: underline;color:#ff0066">decline</a>
							  </span>
						  </td>
					  </tr>
				  </table>
			  </div>
			  <div style="display: flex;flex-direction: row;justify-content: space-between;width: 700px;">
				  <span style="color:#707070 !important;font-size: 12px;">Copyright © 2020 myservy, All rights reserved.</span>
				  <span style="color:#ff0066 !important; margin-left: auto !important;font-size: 12px;">Powered by <b style="color:#ff0066 !important;text-decoration: none;">myservy.com</b></span>
			  </div>
		  </div>
	  </body>
	  </html>`;
    return language == 1 ? htmlEmailEs : htmlEmailEn;
  }

  emailInviteCustomer(
    language: number,
    userName: string,
    pass: any,
    hrefAccept: any
  ) {
    var htmlEmailEs = `<!DOCTYPE html>
	<html>
	<body>
  <div style="width: 700px;min-width:700px;max-width:700px;height: auto !important;max-height: 700px !important;min-height: 667px !important;margin:auto;padding: 10px 30px;background-image: url('${environment.urlservicecenter}/resources/upgrade2.png'), url('${environment.urlservicecenter}/resources/upgrade1.png'), url('${environment.urlservicecenter}/resources/upgrade3.png'), url('${environment.urlservicecenter}/resources/upgrade4.png');background-position: 5% 10%, 5% 65%, 100% 30%, 94% 95%;background-repeat: no-repeat;background-size: 127px 136px, 135px, 134px, 133px 135px;">
			<div style="width: 75%;margin: auto;margin-top: 0px;margin-bottom: 50px;border-radius: 5px;border: none;padding: 15px 25px;display: flex;flex-direction: column;align-items: center;position: relative;min-height: 400px;max-height: 595px;">
				<table style="width: 400px;text-align: center; min-height: 470px;min-width: 512px;">
					<tr>
						<td>
                            <img src="${environment.appurl}/resources/MyservyLogo.png" width="187" height="36" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;margin: auto;">
							<p style="color:#202124;font-size: 14px;margin-bottom: 16px;margin-top: 0px;">Clientes mas cerca de ti</p>

				<h1 style="margin-top: 10px;margin-bottom: 10px;color:#202124;font-size: 33px;">¡Bienvenido, ${userName}!</h1>
				<div style="margin-bottom: 5px;">
					<p style="color: #707070;font-size: 16px;margin: auto;width: 95%;margin-bottom: 20px;margin-top: 20px;">
			  <b>myservy,</b> la primera plataforma de ventas online completa y especializada para la comercialización de servicios profesionales.
					</p>
					<hr style="background-color: #E5E1E1;width: 75%;margin: auto;" />
					<p style="color: #ff0066;font-size: 26px;margin: auto;width: 95%;margin-bottom: 16px;margin-top: 26px;font-weight: bold;">
						¡Ya casi!
					</p>
					<p style='color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px;font-weight: 100;'>
						Su contraseña de acceso es:
						</p>
						<p style='color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px; font-weight: bold;'>
							${pass}
						</p>
					<p style="color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px;">
						Haz clic en el botón que se encuentra abajo para verificar tu email y te ayudaremos a comenzar.
					</p>
					</td>
					</tr>
					<tr>
						<td>
							<a href="${hrefAccept}" class="es-button" target="_blank" style="background:#ff0066;display:inline-block;border-radius:5px;width:auto;margin-top: 20px;margin-bottom:5px;color: white;font-size: 18px;text-decoration: none;padding: 10px 25px;">
                Iniciar sesión
							</a>
						</td>
					</tr>
				</table>
			</div>
			<div style="border-radius: 3px;background-color: #f6f8f9;width: 75%;margin: auto;margin-bottom:50px;display: flex;flex-direction: column;position: relative;padding: 10px 20px;margin-left: 1.5%;">
				<table>
					<tr>
						<td>
							<p style="color: #707070;text-align: left;letter-spacing: normal;line-height: 1.27;font-style: normal;font-stretch: normal;font-weight:300;font-size:11px;font-family:Roboto;margin:0%;">
								Recibiste este email porque realizaste el registro de una cuenta en myservy con esta dirección de email. Si piensas que fue un error, por favor ignora este email, no te preocupes la cuenta aún no ha sido creada.
							</p>
						</td>
					</tr>
					<tr>
						<td>
                            <img src="${environment.appurl}/resources/MyservyLogo.png" width="111" height="21" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;margin-top: 5px;">
						</td>
					</tr>
				</table>
		</div>
			<div style="display: flex;flex-direction: row;justify-content: space-between;width: 700px;">
				<span style="color:#707070 !important">Copyright © 2020 myservy, All rights reserved.</span>
				<span style="color:#ff0066 !important; margin-left: auto !important;">Powered by myservy.com</span>
			</div>
		</div>
	</body>
	</html>`;
    var htmlEmailEn = `<!DOCTYPE html>
	<html>
	<body>
    <div style="width: 700px;min-width:700px;max-width:700px;height: auto !important;max-height: 700px !important;min-height: 667px !important;margin:auto;padding: 10px 30px;background-image: url('${environment.urlservicecenter}/resources/upgrade2.png'), url('${environment.urlservicecenter}/resources/upgrade1.png'), url('${environment.urlservicecenter}/resources/upgrade3.png'), url('${environment.urlservicecenter}/resources/upgrade4.png');background-position: 5% 10%, 5% 65%, 100% 30%, 94% 95%;background-repeat: no-repeat;background-size: 127px 136px, 135px, 134px, 133px 135px;">
			<div style="width: 75%;margin: auto;margin-top: 0px;margin-bottom: 50px;border-radius: 5px;border: none;padding: 15px 25px;display: flex;flex-direction: column;align-items: center;position: relative;min-height: 400px;max-height: 595px;">
				<table style="width: 400px;text-align: center; min-height: 470px;min-width: 512px;">
					<tr>
						<td>
                            <img src="${environment.appurl}/resources/MyservyLogo.png" width="187" height="36" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;margin: auto;">
							<p style="color:#202124;font-size: 14px;margin-bottom: 16px;margin-top: 0px;">Clients closer to you</p>

				<h1 style="margin-top: 10px;margin-bottom: 10px;color:#202124;font-size: 33px;">Welcome, ${userName}!</h1>
				<div style="margin-bottom: 5px;">
					<p style="color: #707070;font-size: 16px;margin: auto;width: 95%;margin-bottom: 20px;margin-top: 20px;">
			  <b>myservy,</b> the first complete and specialized online sales platform for the marketing of professional services
					</p>
					<hr style="background-color: #E5E1E1;width: 75%;margin: auto;" />
					<p style="color: #ff0066;font-size: 26px;margin: auto;width: 95%;margin-bottom: 16px;margin-top: 26px;font-weight: bold;">
						Almost done!
					</p>
					<p style='color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px;font-weight: 100;'>
						Your access password is:
					</p>
					<p style='color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px; font-weight: bold;'>
						${pass}
					</p>
					<p style="color: #707070;font-size: 17px;margin: auto;width: 95%;margin-bottom: 16px;">
						  Click the button below to check your email and we'll help you get started.
					</p>
						</td>
					</tr>
					<tr>
						<td>
							<a href="${hrefAccept}" class="es-button" target="_blank" style="background:#ff0066;display:inline-block;border-radius:5px;width:auto;margin-top: 20px;margin-bottom:5px;color: white;font-size: 18px;text-decoration: none;padding: 10px 25px;">
                Login
							</a>
						</td>
					</tr>
				</table>
			</div>
			<div style="border-radius: 3px;background-color: #f6f8f9;width: 75%;margin: auto;margin-bottom:50px;display: flex;flex-direction: column;position: relative;padding: 10px 20px;margin-left: 1.5%;">
				<table>
					<tr>
						<td>
							<p style="color: #707070;text-align: left;letter-spacing: normal;line-height: 1.27;font-style: normal;font-stretch: normal;font-weight:300;font-size:11px;font-family:Roboto;margin:0%;">
								You received this email because you registered an account on myservy with this email address. If you think it was a mistake, please ignore this email, don't worry the account hasn't been created yet.
							</p>
						</td>
					</tr>
					<tr>
						<td>
                            <img src="${environment.appurl}/resources/MyservyLogo.png" width="111" height="21" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;margin-top: 5px;">
						</td>
					</tr>
				</table>
		</div>
			<div style="display: flex;flex-direction: row;justify-content: space-between;width: 700px;">
				<span style="color:#707070 !important">Copyright © 2020 myservy, All rights reserved.</span>
				<span style="color:#ff0066 !important; margin-left: auto !important;">Powered by myservy.com</span>
			</div>
		</div>
	</body>
	</html>`;
    return language == 1 ? htmlEmailEs : htmlEmailEn;
  }

  emailInviteNewCustomer(
    language: number,
    url_logo: string,
    full_name: string,
    color_account: string,
    account_name: string,
    password: string,
    url_validation: any
  ) {
    var htmlEmailEs = `
<!DOCTYPE html>
<html>
<head>
    <title>Invitación a Service Center</title>
</head>
<body style="margin: 0; padding: 0; background-color: #FAF9F6; font-family: 'Roboto', sans-serif;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#FAF9F6">
        <tr>
            <td align="center">
                <table width="600" cellpadding="0" cellspacing="0" border="0"
                    style="background-color: #ffffff; margin: 30px auto; border-radius: 15px; box-shadow: 0px 8px 24px -4px rgba(151, 161, 175, 0.38); overflow: hidden;">
                    <!-- Content -->
                    <tr>
                        <td style="padding: 40px 30px;">
                            <img src="${url_logo}" alt="Logo"
                                style="width: 100%; max-width: 536px; display: block; margin-bottom: 30px; border-radius: 8px; max-width: 250px; margin: 0 auto;">

                            <h1 style="font-size: 24px; color: ${color_account}; margin-bottom: 10px;">¡Bienvenido, ${full_name}!</h1>
                            <p style="font-size: 16px; color: #444; line-height: 1.5; margin-bottom: 25px;">
                                <b style="color:${color_account};">${account_name}</b>, te invita a ingresar en su
                                oficina digital. Puedes entrar con tu email y la siguiente contraseña.
                            </p>

                            <div style="padding: 20px; border-radius: 8px; text-align: center; margin-bottom: 25px;">
                                <p style="color: #707070; font-size: 17px; margin: 0 0 8px 0;">
                                    Su contraseña de acceso es:
                                </p>
                                <p style="font-weight: bold; font-size: 20px; color: #000; margin: 0;">${password}</p>
                            </div>

                            <div style="text-align: center; margin: 35px 0;">
                                <a href="${url_validation}" target="_blank"
                                    style="background-color: ${color_account}; color: #ffffff; padding: 15px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; display: inline-block;">
                                    INICIAR SESIÓN
                                </a>
                            </div>

                            <p style="font-size: 14px; color: #777; line-height: 1.4;">
                                Recibiste este email porque realizaste el registro de una cuenta en la plataforma myservy
                                con esta dirección de email.
                            </p>
                        </td>
                    </tr>
                    <!-- Footer -->
                    <tr>
                        <td style="background-color: #000; padding: 20px; text-align: center;">
                            <img src="https://sinergyz.com/wp-content/uploads/logo-white-myservy.png" alt="Myservy Logo"
                                width="111" style="margin-bottom: 10px;">
                            <p style="color: #ffffff; font-size: 12px; margin: 0;">© myservy todos los derechos reservados 2024</p>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
    var htmlEmailEn = `
<!DOCTYPE html>
<html>
<head>
    <title>Service Center Invitation</title>
</head>
<body style="margin: 0; padding: 0; background-color: #FAF9F6; font-family: 'Roboto', sans-serif;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#FAF9F6">
        <tr>
            <td align="center">
                <table width="600" cellpadding="0" cellspacing="0" border="0"
                    style="background-color: #ffffff; margin: 30px auto; border-radius: 15px; box-shadow: 0px 8px 24px -4px rgba(151, 161, 175, 0.38); overflow: hidden;">
                    <!-- Content -->
                    <tr>
                        <td style="padding: 40px 30px;">
                            <img src="${url_logo}" alt="Logo"
                                style="width: 100%; max-width: 536px; display: block; margin-bottom: 30px; border-radius: 8px; max-width: 250px; margin: 0 auto;">

                            <h1 style="font-size: 24px; color: ${color_account}; margin-bottom: 10px;">¡Welcome, ${full_name}!</h1>
                            <p style="font-size: 16px; color: #444; line-height: 1.5; margin-bottom: 25px;">
                                <b style="color:${color_account};">${account_name}</b>, invites you to log in to your
                                digital office. You can login with your email address and the following password.
                            </p>

                            <div style="padding: 20px; border-radius: 8px; text-align: center; margin-bottom: 25px;">
                                <p style="color: #707070; font-size: 17px; margin: 0 0 8px 0;">
                                    Your login password is:
                                </p>
                                <p style="font-weight: bold; font-size: 20px; color: #000; margin: 0;">${password}</p>
                            </div>

                            <div style="text-align: center; margin: 35px 0;">
                                <a href="${url_validation}" target="_blank"
                                    style="background-color: ${color_account}; color: #ffffff; padding: 15px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; display: inline-block;">
                                    LOGIN
                                </a>
                            </div>

                            <p style="font-size: 14px; color: #777; line-height: 1.4;">
                                You received this email because you registered an account on the myservy platform with this
                                email address.
                            </p>
                        </td>
                    </tr>
                    <!-- Footer -->
                    <tr>
                        <td style="background-color: #000; padding: 20px; text-align: center;">
                            <img src="https://sinergyz.com/wp-content/uploads/logo-white-myservy.png" alt="Myservy Logo"
                                width="111" style="margin-bottom: 10px;">
                            <p style="color: #ffffff; font-size: 12px; margin: 0;">© myservy all rights reserved 2024</p>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
    return language == 1 ? htmlEmailEs : htmlEmailEn;
  }

  emailInviteExistingCustomer(
    language: number,
    url_logo: string,
    full_name: string,
    color_account: string,
    account_name: string,
    url_validation: any
  ) {
    var htmlEmailEs = `
<!DOCTYPE html>
<html>
<head>
    <title>Vinculación a Service Center</title>
</head>
<body style="margin: 0; padding: 0; background-color: #FAF9F6; font-family: 'Roboto', sans-serif;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#FAF9F6">
        <tr>
            <td align="center">
                <table width="600" cellpadding="0" cellspacing="0" border="0"
                    style="background-color: #ffffff; margin: 30px auto; border-radius: 15px; box-shadow: 0px 8px 24px -4px rgba(151, 161, 175, 0.38); overflow: hidden;">
                    <!-- Content -->
                    <tr>
                        <td style="padding: 40px 30px;">
                            <img src="${url_logo}" alt="Logo"
                                style="width: 100%; max-width: 536px; display: block; margin-bottom: 30px; border-radius: 8px; max-width: 250px; margin: 0 auto;">

                            <h1 style="font-size: 24px; color: ${color_account}; margin-bottom: 10px;">¡Hola, ${full_name}!</h1>
                            <p style="font-size: 16px; color: #444; line-height: 1.5; margin-bottom: 25px;">
                                <b style="color:${color_account};">${account_name}</b>, te ha vinculado como cliente en su
                                oficina digital. Puedes entrar a la plataforma utilizando tus credenciales existentes de Myservy.
                            </p>

                            <div style="text-align: center; margin: 35px 0;">
                                <a href="${url_validation}" target="_blank"
                                    style="background-color: ${color_account}; color: #ffffff; padding: 15px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; display: inline-block;">
                                    INICIAR SESIÓN
                                </a>
                            </div>

                            <p style="font-size: 14px; color: #777; line-height: 1.4;">
                                Recibiste este email porque ya posees una cuenta registrada en la plataforma myservy.
                            </p>
                        </td>
                    </tr>
                    <!-- Footer -->
                    <tr>
                        <td style="background-color: #000; padding: 20px; text-align: center;">
                            <img src="https://sinergyz.com/wp-content/uploads/logo-white-myservy.png" alt="Myservy Logo"
                                width="111" style="margin-bottom: 10px;">
                            <p style="color: #ffffff; font-size: 12px; margin: 0;">© myservy todos los derechos reservados 2024</p>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
    var htmlEmailEn = `
<!DOCTYPE html>
<html>
<head>
    <title>Service Center Link Notification</title>
</head>
<body style="margin: 0; padding: 0; background-color: #FAF9F6; font-family: 'Roboto', sans-serif;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#FAF9F6">
        <tr>
            <td align="center">
                <table width="600" cellpadding="0" cellspacing="0" border="0"
                    style="background-color: #ffffff; margin: 30px auto; border-radius: 15px; box-shadow: 0px 8px 24px -4px rgba(151, 161, 175, 0.38); overflow: hidden;">
                    <!-- Content -->
                    <tr>
                        <td style="padding: 40px 30px;">
                            <img src="${url_logo}" alt="Logo"
                                style="width: 100%; max-width: 536px; display: block; margin-bottom: 30px; border-radius: 8px; max-width: 250px; margin: 0 auto;">

                            <h1 style="font-size: 24px; color: ${color_account}; margin-bottom: 10px;">¡Hello, ${full_name}!</h1>
                            <p style="font-size: 16px; color: #444; line-height: 1.5; margin-bottom: 25px;">
                                <b style="color:${color_account};">${account_name}</b>, has linked you as a customer in their
                                digital office. You can log into the platform using your existing Myservy credentials.
                            </p>

                            <div style="text-align: center; margin: 35px 0;">
                                <a href="${url_validation}" target="_blank"
                                    style="background-color: ${color_account}; color: #ffffff; padding: 15px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; display: inline-block;">
                                    LOGIN
                                </a>
                            </div>

                            <p style="font-size: 14px; color: #777; line-height: 1.4;">
                                You received this email because you already have an account registered on the myservy platform.
                            </p>
                        </td>
                    </tr>
                    <!-- Footer -->
                    <tr>
                        <td style="background-color: #000; padding: 20px; text-align: center;">
                            <img src="https://sinergyz.com/wp-content/uploads/logo-white-myservy.png" alt="Myservy Logo"
                                width="111" style="margin-bottom: 10px;">
                            <p style="color: #ffffff; font-size: 12px; margin: 0;">© myservy all rights reserved 2024</p>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;
    return language == 1 ? htmlEmailEs : htmlEmailEn;
  }
  emailWelcomeMyservy(
    env: string,
    logo: string,
    Name: string,
    content: string,
    len: number
  ) {
    var htmlEmailEs = `<html>
  <body style="margin: 0px;"><table
      cellpadding="0"
      cellspacing="0"
      border="0"
      width="100%"
      bgcolor="#F8F7FF"
      style="padding: 0; margin: 0; line-height: 1px; font-size: 1px">
      <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />
      <tbody>
        <tr style="background-color: #EC0863;height: 62px;">
          <td
            align="center"
            style="padding: 0; margin: 0; line-height: 1px; font-size: 1px; background-color: #EC0863;
    height: 62px;"><table
              class="header"
              align="center"
              width="100%"
              style="
            width: 100%;
            padding: 0;
            margin: 0;
            line-height: 1px;
            font-size: 1px;
                background-color: #EC0863;
    height: 62px;"
              cellpadding="0"
              cellspacing="0"
              border="0"><tbody
                style="
              background-color: #EC0863;
              height: 62px;
            ">
                <tr align="center">

                  <td
                    heigth="62"
                    align="center"
                    style="padding: 0; margin: 0; line-height: 1px; font-size: 1px; background-color: #EC0863;">

                  </td>

                </tr>

              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td heigth="52" style="background-color: #FAF9F6; height: 52px;"></td>
        </tr>
        <tr>
          <td
            align="center"
            style="padding: 0; margin: 0; line-height: 1px; font-size: 1px; background-color: #FAF9F6">
            <table>
              <tbody>

              </tbody>
            </table>
            <table
              align="center"
              width="600"
              style="
            width: 100%;
            background-color: #ffffff;
            padding: 0;
            margin: 0;
            line-height: 1px;
            font-size: 1px;
          "
              bgcolor="#ffffff"
              cellpadding="0"
              cellspacing="0"
              border="0">
              <tbody style="position: relative;
    z-index: 99;">
                <tr align="left;">

                  <td
                    align="left;"
                    style="padding: 0; margin: 0; line-height: 1px; font-size: 1px; background-color: #FAF9F6;
                ">
                    <table
                      cellpadding="0"
                      cellspacing="0"
                      border="0"
                      style="
                    padding: 30px;
                    margin: 0 auto;
                    line-height: 1px;
                    font-size: 1px;
                      min-height: 339px;
    background-color: #fff;
    box-shadow: 0px 8px 24px -4px rgba(151, 161, 175, 0.38);
        max-width: 536px;
    border-radius: 15px;
    margin-bottom: 33px;




                  ">
                      <tbody>
                        <tr>
                          <td>
                            <img style="margin: 0 auto;

              max-width: 300px;
              background: #FAF9F6;
                  display: block;
              height: 90px;
              margin-bottom: 15px;
              " src="${logo}">
                            <p
                              style="color:#202124;font-size: 14px;margin-bottom: 16px;margin-top: 20px; text-align: center;">Clientes
                              mas cerca de ti</p>
                          </td>
                        </tr>
                        <tr>
                          <td style="
                          padding: 10px;
                          margin: 10px;
                          line-height: 1px;
                          font-size: 1px;
                        "></td>
                        </tr>
                        <tr>
                          <td
                            align="left;"
                            style="
                padding: 0;
                margin: 0;
                line-height: 1px;
                font-family: 'Roboto', sans-serif;
                font-size: 24px;
                line-height: 30px;
                font-weight: 700;
                color: #000;
                text-align: center;
                text-decoration: none;
              ">
                            <span style="color: #EC0863;">¡Bienvenido,
                              ${Name}!</span>
                          </td>

                        </tr>

                        <tr>
                          <td
                            align="left;"
                            style="
                          padding: 0;
                          margin: 0;
                          color: #1D1D1B;
                          font-family: 'Roboto', sans-serif;
                          font-size: 20px;
                          font-style: normal;
                          font-weight: 600;
                          line-height: 130%;
                          letter-spacing: 0.24px;
                          text-align: left;
                          text-decoration: none;
                        ">

                          </td>
                        </tr>
                        <tr>
                          <td
                            align="left;"
                            style="
                          padding: 0;
                          margin: 0;
                          color: #1D1D1B;
                          font-family: 'Roboto', sans-serif;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 600;
                          line-height: 130%;
                          letter-spacing: 0.24px;
                          text-align: left;
                          text-decoration: none;
                        ">

                          </td>
                        </tr>
                        <tr>
                          <td
                            style="
                          padding: 10px;
                          margin: 10px;
                          line-height: 1px;
                          font-size: 1px;
                        "></td>
                        </tr>
                        <tr>
                          <td
                            height="6"
                            style="
                          padding: 0;
                          margin: 0;
                          line-height: 1px;
                          font-size: 1px;
                        "></td>
                        </tr>
                        <tr>
                          <td
                            height="6"
                            style="
                          padding: 0;
                          margin: 0;
                          line-height: 1px;
                          font-size: 1px;
                        "></td>
                        </tr>
                        <tr>
                          <td
                            style="
                          padding: 0;
                          margin: 0;
                          line-height: 1px;
                          font-size: 1px;
                        ">
                            <table
                              width="100%"
                              align="center"
                              cellspacing="0"
                              border="0"
                              style="
                            padding: 0;
                            margin: 0;
                            line-height: 1px;
                            font-size: 1px;
                          ">
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style="
                                  padding: 0;
                                  margin: 0;
                                  line-height: 1px;
                                  font-size: 1px;
                                "></td>
                                </tr>

                                <tr align="center">
                                  <td
                                    align="center;"
                                    style="
                                    align-items: center;
                                    padding: 0;
                                    margin: 0;
                                    line-height: 16px;
                                    font-size: 1px;
                                    font-family: 'Roboto', sans-serif;

                                    line-height: 20px;

                                    color: #1e1e1e;
                                    text-align: left;
                                    text-decoration: none;
                                        font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24.4px;
margin-bottom: 10px;
                                  ">
                                    <p><strong>myservy</strong>, la primera
                                      plataforma de ventas online completa y
                                      especializada para la comercialización de
                                      servicios profesionales.</p>

                                    <hr
                                      style="margin-top: 20px; margin-bottom: 20px;">

                                    <th
                                      align="center"
                                      style="
                                    padding: 0;
                                    margin: 0px;
                                    line-height: 1px;
                                    font-size: 1px;
                                    font-family: 'Roboto', sans-serif;
                                    text-decoration: none;
                                    height: 34px;
                                  ">

                                    </th>

                                  </td>
                                </tr>
                                <tr>
                                  <td align="center;" style="
                                    padding: 0;
                                    margin: 0;
                                    line-height: 1px;
                                    font-family: 'Roboto', sans-serif;
                                    font-size: 24px;
                                    line-height: 30px;
                                    font-weight: 700;
                                    color: #000;
                                    text-align: center;
                                    text-decoration: none;
                                  ">
                                    <span style="color: #EC0863;">¡Ya
                                      casi!</span>
                                  </td>

                                </tr>
                                <tr height="20">
                                  <td></td>
                                </tr>

                                <table>
                                  <tbody>
                                    <tr align="center">
                                      <td
                                        align="center;"
                                        style="
                              align-items: center;
                              padding: 0;
                              margin: 0;
                              line-height: 16px;
                              font-size: 1px;
                              font-family: 'Roboto', sans-serif;

                              line-height: 20px;

                              color: #1e1e1e;
                              text-align: left;
                              text-decoration: none;
                                  font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24.4px;
margin-bottom: 10px;
                            ">

                                        <p>¡Gracias por registrarte en myservy!
                                          Haz clic en el botón que se encuentra
                                          abajo para verificar tu email y te
                                          ayudaremos a comenzar.</p>

                                        <th
                                          align="center"
                                          style="
                              padding: 0;
                              margin: 0px;
                              line-height: 1px;
                              font-size: 1px;
                              font-family: 'Roboto', sans-serif;
                              text-decoration: none;
                              height: 34px;
                            ">

                                        </th>

                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <tr height="40">
                                  <td></td>
                                </tr>
                                <tr align="center">
                                  <td
                                    align="center"
                                    style="
                                        padding: 0;
                                        margin: 0px;
                                        line-height: 1px;
                                        font-size: 1px;
                                        font-family: 'Roboto', sans-serif;
                                        text-decoration: none;
                                      ">
                                    <a
                                      href="${env}/${content}"
                                      class="es-button"
                                      target="_blank"
                                      style="
                                          align-items: center;
                                          font-size: 15px;
                                          line-height: 18px;
                                          font-weight: 400;
                                          background-color: #EC0863;
                                          color: #fff;
                                          text-align: center;
                                          padding: 10px 10px;
                                          border-radius: 15px;
                                          text-decoration: none;
                                          font-weight: 600;
                                          box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.20), 0px 2px 1px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14);
                                        width: 234px;
                                        display: inline-block
                                        ">Verificar dirección de email</a>
                                  </td>
                                </tr>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>

                    </tbody>
                  </table>

                  <table style="background-color: #FAF9F6;      width: 600px;
    margin-left: auto;
    margin-right: auto;   padding: 0px 33px 55px 40px;"><tbody><tr><td><p
                            style="color: var(--Neutro-Gris-Oscuro, #7B7B7B);

    align-items: center;
    padding: 0;
    margin: 0;
    line-height: 16px;
    font-size: 1px;
    font-family: 'Roboto', sans-serif;
    line-height: 20px;
    color: #1e1e1e;
    text-align: left;
    text-decoration: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24.4px;
    margin-bottom: 10px;"></td></tr>
                        <tr style="text-align: left;">
                          <td>
                            <p style="margin-top: 8px;white-space: normal">
                              <p
                                style="color: var(--Neutro-Gris-Oscuro, #7B7B7B);

/* Body/B2 */
font-family: Roboto;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 142.857% */
letter-spacing: 0.035px;">Recibiste este email porque realizaste el registro de
                                una cuenta en myservy con esta dirección de
                                email. Si piensas que fue un error, por favor
                                ignora este email, no te preocupes la cuenta aún
                                no ha sido creada.</p>

                            </p>
                          </td>
                        </tr>
                      </tbody></table>
                    <table class="footer" cellpadding="0" cellspacing="0"
                      border="0" width="100%" align="center" style="
background-color: #000;
padding: 29px 36px;
margin: 0;
line-height: 1.1rem;
font-size: 1px;
">
                      <tbody>
                        <tr>
                          <th style="width: 50%">
                            <a href="https://myservy.com/">
                              <img
                                src="https://myservy.com/wp-content/uploads/2024/03/myservy-logo-blanco-service-centter-footer.png"
                                width="111" height="21" style="
          display: block;
          border: 0;
          outline: none;
          text-decoration: none;
          margin: auto;
          margin-top: 5px;
          height: auto;
              max-width: 99px;
width: 99px;
text-align: left;
margin-left: 0px;
        ">
                            </a>
                          </th>

                          <th style="width: 50%">

                            <p style="
       color: #FFF;

/* Caption/Caption */
font-family: Roboto;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 16px; /* 133.333% */
letter-spacing: 0.048px;
text-align: right;
margin-right: 0px;
      ">
                              © myservy todos los derechos reservados 2023
                            </p>
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

      </tbody>
    </table>
  </body>
</html>`;
    var htmlEmailEn = `<html>
<body style="margin: 0px;"><table
  cellpadding="0"
  cellspacing="0"
  border="0"
  width="100%"
  bgcolor="#F8F7FF"
  style="padding: 0; margin: 0; line-height: 1px; font-size: 1px"
>
<meta http-equiv="Content-Type" content="text/html charset=UTF-8" />
  <tbody>
    <tr style="background-color: #EC0863;height: 62px;">
      <td
        align="center"
        style="padding: 0; margin: 0; line-height: 1px; font-size: 1px; background-color: #EC0863;
    height: 62px;"><table
          class="header"
          align="center"
          width="100%"
          style="
            width: 100%;
            padding: 0;
            margin: 0;
            line-height: 1px;
            font-size: 1px;
                background-color: #EC0863;
    height: 62px;"
          cellpadding="0"
          cellspacing="0"
          border="0"
        ><tbody
            style="
              background-color: #EC0863;
              height: 62px;
            "
          >
            <tr align="center">

              <td
               heigth="62"

                align="center"
                style="padding: 0; margin: 0; line-height: 1px; font-size: 1px; background-color: #EC0863;"
              >

              </td>

            </tr>

          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td heigth="52" style="background-color: #FAF9F6; height: 52px;"></td>
    </tr>
    <tr>
      <td
        align="center"
        style="padding: 0; margin: 0; line-height: 1px; font-size: 1px; background-color: #FAF9F6"
      >
        <table>
        <tbody>

        </tbody>
      </table>
        <table
          align="center"
          width="600"
          style="
            width: 100%;
            background-color: #ffffff;
            padding: 0;
            margin: 0;
            line-height: 1px;
            font-size: 1px;
          "
          bgcolor="#ffffff"
          cellpadding="0"
          cellspacing="0"
          border="0"
        >
          <tbody style="position: relative;
    z-index: 99;">
            <tr align="left;">

              <td
                align="left;"
                style="padding: 0; margin: 0; line-height: 1px; font-size: 1px; background-color: #FAF9F6;
                "
              >
                     <table
                  cellpadding="0"
                  cellspacing="0"
                  border="0"
                  style="
                    padding: 30px;
                    margin: 0 auto;
                    line-height: 1px;
                    font-size: 1px;
                      min-height: 339px;
    background-color: #fff;
    box-shadow: 0px 8px 24px -4px rgba(151, 161, 175, 0.38);
        max-width: 536px;
    border-radius: 15px;
    margin-bottom: 33px;




                  "
                >
                  <tbody>
                    <tr>
                      <td>
                        <img style="margin: 0 auto;

              max-width: 300px;
              background: #FAF9F6;
                  display: block;
              height: 90px;
              margin-bottom: 15px;
              " src="${logo}">
              <p style="color:#202124;font-size: 14px;margin-bottom: 16px;margin-top: 20px; text-align: center;">Clients closer to you              </p>
                      </td>
                    </tr>
                    <tr>
                      <td style="
                          padding: 10px;
                          margin: 10px;
                          line-height: 1px;
                          font-size: 1px;
                        "></td>
                    </tr>
          <tr>
            <td
              align="left;"
              style="
                padding: 0;
                margin: 0;
                line-height: 1px;
                font-family: 'Roboto', sans-serif;
                font-size: 24px;
                line-height: 30px;
                font-weight: 700;
                color: #000;
                text-align: center;
                text-decoration: none;
              "
            >
            <span style="color: #EC0863;">Welcome, ${Name}!</span>
            </td>

          </tr>

                    <tr>
                      <td
                        align="left;"
                        style="
                          padding: 0;
                          margin: 0;
                          color: #1D1D1B;
                          font-family: 'Roboto', sans-serif;
                          font-size: 20px;
                          font-style: normal;
                          font-weight: 600;
                          line-height: 130%;
                          letter-spacing: 0.24px;
                          text-align: left;
                          text-decoration: none;
                        "
                      >

                      </td>
                    </tr>
                      <tr>
                      <td
                        align="left;"
                        style="
                          padding: 0;
                          margin: 0;
                          color: #1D1D1B;
                          font-family: 'Roboto', sans-serif;
                          font-size: 16px;
                          font-style: normal;
                          font-weight: 600;
                          line-height: 130%;
                          letter-spacing: 0.24px;
                          text-align: left;
                          text-decoration: none;
                        "
                      >

                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding: 10px;
                          margin: 10px;
                          line-height: 1px;
                          font-size: 1px;
                        "
                      ></td>
                    </tr>
                    <tr>
                      <td
                        height="6"
                        style="
                          padding: 0;
                          margin: 0;
                          line-height: 1px;
                          font-size: 1px;
                        "
                      ></td>
                    </tr>
                    <tr>
                      <td
                        height="6"
                        style="
                          padding: 0;
                          margin: 0;
                          line-height: 1px;
                          font-size: 1px;
                        "
                      ></td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding: 0;
                          margin: 0;
                          line-height: 1px;
                          font-size: 1px;
                        "
                      >
                        <table
                          width="100%"
                          align="center"
                          cellspacing="0"
                          border="0"
                          style="
                            padding: 0;
                            margin: 0;
                            line-height: 1px;
                            font-size: 1px;
                          "
                        >
                          <tbody>
                            <tr>
                              <td
                                align="center"
                                style="
                                  padding: 0;
                                  margin: 0;
                                  line-height: 1px;
                                  font-size: 1px;
                                "
                              ></td>
                              </tr>

                              <tr align="center">
                                <td
                                  align="center;"
                                  style="
                                    align-items: center;
                                    padding: 0;
                                    margin: 0;
                                    line-height: 16px;
                                    font-size: 1px;
                                    font-family: 'Roboto', sans-serif;

                                    line-height: 20px;

                                    color: #1e1e1e;
                                    text-align: left;
                                    text-decoration: none;
                                        font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24.4px;
margin-bottom: 10px;
                                  "
                                >
<p><strong>myservy</strong>, the first complete and specialized online sales platform for the marketing of professional services</p>

<hr style="margin-top: 20px; margin-bottom: 20px;">



                                 <th
                                  align="center"
                                  style="
                                    padding: 0;
                                    margin: 0px;
                                    line-height: 1px;
                                    font-size: 1px;
                                    font-family: 'Roboto', sans-serif;
                                    text-decoration: none;
                                    height: 34px;
                                  "
                                >

                                </th>

                                </td>
                              </tr>
                               <tr>
                                <td align="center;" style="
                                    padding: 0;
                                    margin: 0;
                                    line-height: 1px;
                                    font-family: 'Roboto', sans-serif;
                                    font-size: 24px;
                                    line-height: 30px;
                                    font-weight: 700;
                                    color: #000;
                                    text-align: center;
                                    text-decoration: none;
                                  ">
                                <span style="color: #EC0863;">Almost done!</span>
                                </td>

                              </tr>
                              <tr height="20">
                                <td></td>
                               </tr>

                       <table>
                       <tbody>
                         <tr align="center">
                          <td
                            align="center;"
                            style="
                              align-items: center;
                              padding: 0;
                              margin: 0;
                              line-height: 16px;
                              font-size: 1px;
                              font-family: 'Roboto', sans-serif;

                              line-height: 20px;

                              color: #1e1e1e;
                              text-align: left;
                              text-decoration: none;
                                  font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24.4px;
margin-bottom: 10px;
                            "
                          >



<p>Thanks for signing up for myservy! Click the button below to check your email and we'll help you get started.</p>

                          <th
                            align="center"
                            style="
                              padding: 0;
                              margin: 0px;
                              line-height: 1px;
                              font-size: 1px;
                              font-family: 'Roboto', sans-serif;
                              text-decoration: none;
                              height: 34px;
                            "
                          >

                          </th>

                          </td>
                        </tr>
                      </tbody>
                    </table>
                         <tr height="40">
                          <td ></td>
                         </tr>
                              <tr align="center">
                                    <td
                                      align="center"
                                      style="
                                        padding: 0;
                                        margin: 0px;
                                        line-height: 1px;
                                        font-size: 1px;
                                        font-family: 'Roboto', sans-serif;
                                        text-decoration: none;
                                      "
                                    >
                                      <a
                                        href="${env}/${content}"
                                        class="es-button"
                                        target="_blank"
                                        style="
                                          align-items: center;
                                          font-size: 15px;
                                          line-height: 18px;
                                          font-weight: 400;
                                          background-color: #EC0863;
                                          color: #fff;
                                          text-align: center;
                                          padding: 10px 10px;
                                          border-radius: 15px;
                                          text-decoration: none;
                                          font-weight: 600;
                                          box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.20), 0px 2px 1px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14);
                                        width: 234px;
                                        display: inline-block
                                        "
                                        >Verify email address</a>
                                    </td>
                                  </tr>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>


                  </tbody>
                </table>

<table style="background-color: #FAF9F6;      width: 600px;
    margin-left: auto;
    margin-right: auto;   padding: 0px 33px 55px 40px;"><tbody><tr><td><p style="color: var(--Neutro-Gris-Oscuro, #7B7B7B);

    align-items: center;
    padding: 0;
    margin: 0;
    line-height: 16px;
    font-size: 1px;
    font-family: 'Roboto', sans-serif;
    line-height: 20px;
    color: #1e1e1e;
    text-align: left;
    text-decoration: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24.4px;
    margin-bottom: 10px;"></td></tr>
<tr style="text-align: left;">
  <td>
    <p style="margin-top: 8px;white-space: normal">
      <p style="color: var(--Neutro-Gris-Oscuro, #7B7B7B);

/* Body/B2 */
font-family: Roboto;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 142.857% */
letter-spacing: 0.035px;">You received this email because you registered an account on myservy with this email address. If you think it was a mistake, please ignore this email, don't worry the account hasn't been created yet.</p>



                                        </p>
  </td>
</tr>
</tbody></table>
<table class="footer" cellpadding="0" cellspacing="0" border="0" width="100%" align="center" style="
background-color: #000;
padding: 29px 36px;
margin: 0;
line-height: 1.1rem;
font-size: 1px;
">
<tbody>
<tr>
   <th style="width: 50%">
    <a href="https://myservy.com/">
      <img src="https://myservy.com/wp-content/uploads/2024/03/myservy-logo-blanco-service-centter-footer.png" width="111" height="21" style="
          display: block;
          border: 0;
          outline: none;
          text-decoration: none;
          margin: auto;
          margin-top: 5px;
          height: auto;
              max-width: 99px;
width: 99px;
text-align: left;
margin-left: 0px;
        ">
    </a>
  </th>

  <th style="width: 50%">

    <p style="
       color: #FFF;

/* Caption/Caption */
font-family: Roboto;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 16px; /* 133.333% */
letter-spacing: 0.048px;
text-align: right;
margin-right: 0px;
      ">
    © myservy all rights reserved 2023
    </p>
  </th>
</tr>
</tbody>
</table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>

  </tbody>
</table>
</body>
</html>`;
    return len == 1 ? htmlEmailEs : htmlEmailEn;
  }
}
